import React from 'react';

/** Rótulo que agrupa um bloco do menu. No modo colapsado vira apenas um traço. */
export default props => (
  <li className="menu-section" role="presentation">
    <span className="menu-section-label">{props.label}</span>
    <span className="menu-section-line" aria-hidden="true" />
  </li>
);
